import { createEffect } from 'effector';
import dayjs from 'dayjs';
import JSZip from 'jszip';
import { api } from '../../api/axiosinstance.js';

export const sendCreateLitePresetFx = createEffect().use(async (payload) => {
  const { data } = await api(true).post('presets/lite', payload);
  return {
    ...data,
    ...(Object.hasOwn(payload, 'id') ? { old_id: payload.id } : {}),
  };
});

export const downloadReportFx = createEffect().use(async (payload) => {
  return {
    data: (await api(true, 'blob').get(`reports/lite/${payload.id}`)).data,
    name: payload.name,
  };
});

export const renamePresetFx = createEffect().use(async ({ id, data }) => {
  const response = await api(true).put(`presets/${id}`, data);
  if (response.status === 200) {
    return {
      data,
      id,
    };
  }
});

export const deleteLitePresetFx = createEffect().use(async (id) => {
  const payload = {
    ids: Array.isArray(id) ? id : [id],
  };
  const response = await api(true).delete(`presets/`, { data: payload });
  if (response.status === 200) return id;
  return null;
});

export const getBuildingInfoFx = createEffect().use(async ({ lat, lon }) => {
  return (await api().get(`map/building_info?lat=${lat}&lon=${lon}`)).data;
});

export const sendCreateReportFx = createEffect().use(async (payload) => {
  return {
    ...(await api().post('reports-location/', payload)).data,
    preset_id: payload.preset_id,
  };
});

export const checkReportStatusFx = createEffect().use(async (payload) => {
  return (await api().get(`reports-location/${payload}`)).data;
});

export const downloadReportLocationFx = createEffect().use(async (payload) => {
  return (
    await api(true, 'blob').get(
      `reports-location/download/${payload.reports_location_id}`
    )
  ).data;
});

export const generateZipFx = createEffect().use(async (payload) => {
  let { excel, pdf } = payload;
  const { name } = excel;
  excel = excel.data;
  const zip = new JSZip();

  const excelBlob = new Blob([excel], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  zip.file(`${name}.xlsx`, excelBlob);
  const pdfBlob = new Blob([pdf], {
    type: 'application/pdf',
  });
  zip.file(`${name}.pdf`, pdfBlob);

  const zipBlob = await zip.generateAsync({ type: 'blob' });

  const url = window.URL.createObjectURL(zipBlob);
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.download = `${name}_${dayjs().format('YYYY-MM-DD:HH:mm')}.zip`;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
});
